import Controller from '../user_multisearch_controller'
export default Controller